<script setup>

</script>
<template>
<i>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M19.5455 16.6364C19.5455 17.0221 19.3922 17.3921 19.1194 17.6649C18.8466 17.9377 18.4767 18.0909 18.0909 18.0909H6.45455C6.06878 18.0909 5.69881 17.9377 5.42603 17.6649C5.15325 17.3921 5 17.0221 5 16.6364V6.45456C5 6.06879 5.15325 5.69882 5.42603 5.42604C5.69881 5.15326 6.06878 5.00002 6.45455 5.00002H10.0909L11.5455 7.18183H18.0909C18.4767 7.18183 18.8466 7.33508 19.1194 7.60786C19.3922 7.88064 19.5455 8.25061 19.5455 8.63638V16.6364Z" fill="#F9FAFB" stroke="#B0B0B0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</i>
</template>
<style scoped>

</style>